"use strict";
//
// Copyright © 2020, 2021 Anticrm Platform Contributors.
// Copyright © 2023 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactPlugin = exports.contactId = exports.AvatarType = void 0;
const platform_1 = require("@hcengineering/platform");
/**
 * @public
 */
var AvatarType;
(function (AvatarType) {
    AvatarType["COLOR"] = "color";
    AvatarType["IMAGE"] = "image";
    AvatarType["GRAVATAR"] = "gravatar";
    AvatarType["EXTERNAL"] = "external";
})(AvatarType || (exports.AvatarType = AvatarType = {}));
/**
 * @public
 */
exports.contactId = 'contact';
/**
 * @public
 */
exports.contactPlugin = (0, platform_1.plugin)(exports.contactId, {
    class: {
        AvatarProvider: '',
        ChannelProvider: '',
        SocialIdentityProvider: '',
        Channel: '',
        Contact: '',
        Person: '',
        Member: '',
        Organization: '',
        Status: '',
        ContactsTab: '',
        PersonSpace: '',
        SocialIdentity: '',
        UserProfile: '',
        UserRole: '',
        Translation: '',
        RecentlyUsedPersonsPreference: ''
    },
    mixin: {
        Employee: ''
    },
    component: {
        SocialEditor: '',
        CreateOrganization: '',
        CreatePerson: '',
        ChannelsPresenter: '',
        MembersPresenter: '',
        Avatar: '',
        AvatarRef: '',
        UserBoxList: '',
        ChannelPresenter: '',
        SpaceMembers: '',
        DeleteConfirmationPopup: '',
        PersonIdArrayEditor: '',
        AccountArrayEditor: '',
        PersonIcon: '',
        EditOrganizationPanel: '',
        CollaborationUserAvatar: '',
        CreateGuest: '',
        SpaceMembersEditor: '',
        ContactNamePresenter: '',
        PersonFilterValuePresenter: '',
        PersonIdFilter: '',
        AssigneePopup: '',
        EmployeePresenter: '',
        CollaboratorEditor: ''
    },
    channelProvider: {
        Email: '',
        Phone: '',
        LinkedIn: '',
        Twitter: '',
        Telegram: '',
        GitHub: '',
        Facebook: '',
        Homepage: '',
        Whatsapp: '',
        Profile: '',
        Viber: ''
    },
    socialIdentityProvider: {
        Huly: '',
        Email: '',
        Phone: '',
        Google: '',
        GitHub: '',
        Telegram: ''
    },
    avatarProvider: {
        Color: '',
        Image: '',
        Gravatar: ''
    },
    function: {
        GetColorUrl: '',
        GetFileUrl: '',
        GetGravatarUrl: '',
        GetExternalUrl: '',
        CollaboratorsApplier: ''
    },
    icon: {
        ContactApplication: '',
        Phone: '',
        Email: '',
        Huly: '',
        Discord: '',
        Facebook: '',
        Instagram: '',
        LinkedIn: '',
        Telegram: '',
        Google: '',
        Twitter: '',
        VK: '',
        WhatsApp: '',
        Youtube: '',
        GitHub: '',
        Edit: '',
        Person: '',
        Persona: '',
        Company: '',
        SocialEdit: '',
        Homepage: '',
        Whatsapp: '',
        ComponentMembers: '',
        Profile: '',
        KickUser: '',
        Contacts: '',
        Viber: '',
        Clock: '',
        Chat: '',
        User: ''
    },
    image: {
        ProfileBackground: '',
        ProfileBackgroundLight: ''
    },
    space: {
        Contacts: ''
    },
    app: {
        Contacts: ''
    },
    metadata: {
        LastNameFirst: ''
    },
    string: {
        PersonAlreadyExists: '',
        SeatLimitReached: '',
        Person: '',
        Employee: '',
        CreateOrganization: '',
        UseImage: '',
        UseGravatar: '',
        UseColor: '',
        PersonFirstNamePlaceholder: '',
        PersonLastNamePlaceholder: '',
        NumberMembers: '',
        Position: '',
        For: '',
        SelectUsers: '',
        AddGuest: '',
        Members: '',
        Contacts: '',
        Employees: '',
        Persons: '',
        ViewProfile: '',
        SocialId: '',
        SocialIds: '',
        Type: '',
        Confirmed: '',
        UserProfile: '',
        DeactivatedAccount: '',
        LocalTime: '',
        Timezone: '',
        Everyone: '',
        Here: '',
        EveryoneDescription: '',
        HereDescription: '',
        Guest: '',
        Deleted: '',
        Email: ''
    },
    viewlet: {
        TableMember: '',
        TablePerson: '',
        TableEmployee: '',
        TableOrganization: '',
        TableUserProfile: ''
    },
    filter: {
        FilterChannelIn: '',
        FilterChannelNin: '',
        FilterChannelHasMessages: '',
        FilterChannelHasNewMessages: ''
    },
    resolver: {
        Location: ''
    },
    templateFieldCategory: {
        CurrentEmployee: '',
        Contact: ''
    },
    templateField: {
        CurrentEmployeeName: '',
        CurrentEmployeePosition: '',
        CurrentEmployeeEmail: '',
        ContactName: '',
        ContactFirstName: '',
        ContactLastName: ''
    },
    ids: {
        MentionCommonNotificationType: ''
    },
    mention: {
        Everyone: '',
        Here: ''
    },
    extension: {
        EmployeePopupActions: '',
        PersonAchievementsPresenter: ''
    },
    store: {
        Permissions: ''
    }
});
exports.default = exports.contactPlugin;
__exportStar(require("./types"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./analytics"), exports);
__exportStar(require("./avatar"), exports);
//# sourceMappingURL=index.js.map